<template>
  <div class="content if-profile">
    <CPHeader :headerData="ifInfo ? ifInfo : ''"/>
    <div class="md-layout finanical-insights-body">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
        <div class="navbar md-toolbar md-transparent md-elevation-4 p-0">
          <div class="md-toolbar-row p-0">
            <nav-tabs-card class="profile-layout-tbs if_card">
              

              <template slot="content">
                  <md-tabs md-alignment="left" class="p-0">
                <md-tab
                    id="cash-flow"
                    md-label="Value Proposition"
                    md-icon="join_inner"
                    class="p-0 ss"
                  >
                 <div class="md-toolbar-row fundamentals_area p-0">  
                 <ValueProposition/>
                 </div>
                 </md-tab>

                  <md-tab
                    id="about-the-data"
                    md-label="Data"
                    md-icon="description"
                    class="p-0"
                  >
                 <div class="md-toolbar-row fundamentals_area p-0">  
                  <md-card>
                    <div class="md-layout">
                      <div class="md-toolbar-row map-box-title p-0">
                        <div class="md-layout">
                          <md-card-header>
                            <!-- <h1 class="md-title text-left profile-title"> -->
                              Data
                            <!-- </h1> -->
                          </md-card-header>
                        </div>
                      </div>
                      <div class="md-layout company-terms">
                        <div class="md-layout-item md-medium-size-100 md-size-100 p-0">


                          <md-card class="m-0">
                            <md-card-content>
                              <div class="extra_space">
                               <p>
                        Bizminer data comes from three categories of data, public data like that from the Census Bureau, private data like that through our partnership with Data Axle and finally, meta data, the data that is generated by activity across the web. None of these raw data sources creates the final measures reflected in Bizminer products. In total, Bizminer accesses over a billion sourced data points from 16 million business operations for each of its updates covering a 3 to 5 year time series. Historical data and Bizminer algorithms are used to inform and test projections for non-reporting firms. Data elements are sourced specifically from:

                        <ul>
                        <li>IRS SOI Corporation Tax Book</li>
                        <li>IRS Statistics of Income</li>
                        <li>US Economic Census</li>
                        <li>US Census Quarterly Financial Reports</li>
                        <li>US Census County Business Patterns</li>
                        <li>Bureau of Labor Statistics Monthly Employment Reports</li>
                        <li>Bureau of Labor Statistics Monthly Unemployment Reports</li>
                        <li>Bureau of Labor Statistics Annual Wage Survey</li>
                        <li>Bureau of Labor Statistics Industry Productivity</li>
                        <li>Bureau of Labor Statistics Price Indices</li>
                        <li>National Agricultural Statistical Service</li>
                        <li>US Census Quarterly Financial Reports</li>
                        <li>US Census Retail Trade Report</li>
                        <li>Data Axle</li>
                        <li>Business Valuation Resources (BVR)</li>
                        <li>Credit Reporting Agencies</li>
                        <li>Business Directories</li>
                        <li>American Community Survey</li>

                        </ul>
                      </p>

                      <p>Our data is refreshed as the source data is refreshed resulting in the most up to date, accurate analysis available on the market. While 100% firm coverage is desirable for analysis purposes, the greatest value of Bizminer products rests in discerning patterns of activity, which are reflected in the large samples used to develop our products. The overall current coverage of the databases surpasses 16 million active business operations at any point in time. As is the case with any databases this large, some errors are inevitable. Some firms are missed and specific information on others is lacking from the database. Not all information received is uniform or complete, resulting in the need to develop projection algorithms for specific industry segments and metrics in some report series. No representation is made as to the accuracy of the databases utilized or the results of subsequent analyses.</p>
                      <p>Bizminer data is widely accepted for industry analytical work, benchmarking, valuations, forensics and litigation. Bizminer content is accepted in US Tax Court (Bauer vs. IRS: T.C. Memo. 2012-156) and is utilized by state, provincial and national taxing agencies in the US and Canada.</p><br>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                      </div>
                    </div>
                  </md-card>
                 </div>
                 </md-tab>
                 </md-tabs> 
              </template>
            </nav-tabs-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {NavTabsCard} from "@/components";
import CPHeader from "./_partials/CPHeader.vue";
import { mapState } from 'vuex';
import ValueProposition from './ValueProposition.vue';

export default {
  components: {
    NavTabsCard,
    CPHeader,
    ValueProposition
  },
  data() {
    return {
      filtered_company_profile_list: []
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
    }),
    ifInfo() {
      return this.$store.getters.profileInfo;
    },
    getFormattedData() {
      let a = {};

      a.company = this.ifInfo.companyTitle;
      a.original_name = "";
      a.infogroup = this.ifInfo.locnum;
      a.unique_id = "";
      a.street = this.ifInfo.street?this.ifInfo.street:"";
      a.city = this.ifInfo.city?this.ifInfo.city:"";
      a.state = this.ifInfo.state?this.ifInfo.state:"";
      a.zip = this.ifInfo.zip?this.ifInfo.zip:"";
      a.industry_code = this.ifInfo.naics;
      a.industry = this.ifInfo.industry;


      let b = this.ifInfo.businessOwner?this.ifInfo.businessOwner.split(',')[0]:"";
      a.contact_first = b.split(' ')[0];
      a.contact_last = b.split(' ')[1];
      a.phone = this.ifInfo.businessPhone?this.ifInfo.businessPhone:"";
      a.url = this.ifInfo.businessURL?this.ifInfo.businessURL:"";
      let g = this.ifInfo.release_id.replace("_","-01-20");
      const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];


      a.operation_details = monthNames[new Date(g).getMonth()] + " " + new Date(g).getFullYear();
      a.location_annual_sales = this.ifInfo.bizop['Location Sales'][0];
      a.location_employment = this.ifInfo.bizop['Employment'][0]
      a.corporation_annual_sales = this.ifInfo.bizop['Corporate Sales'][0]
      a.corporation_employment = this.ifInfo.bizop['Corporate Employment'][0]

      a.market_insights_date = monthNames[new Date(g).getMonth()] + " " + new Date(g).getFullYear();
      a.market_industry_code = this.ifInfo.IMRnaics
      a.market_industry = this.ifInfo.IMRindustry
      a.market_area = this.ifInfo['MR']['area']

      a.industry_operations = this.ifInfo['MR']['main']['Industry Operations']
      a.location_sales_rank = this.ifInfo['MR']['main']['Business Sales Rank']
      a.industry_market_sales_volume = this.ifInfo['MR']['main']['Annual Market Sales Volume']
      a.average_site_sales = this.ifInfo['MR']['main']['Average Site Sales']
      a.average_small_business_sales = this.ifInfo['MR']['main']['Average Small Business Sales']

      a.industry_market_sales_per_person = this.ifInfo['MR']['penetration']['Market Sales per Person']
      a.us_industry_sales_per_person = this.ifInfo['MR']['penetration']['US Sales per Person']
      a.opportunity_index_person = this.ifInfo['MR']['penetration']['Opportunity Index Person']
      a.industry_market_sales_per_household = this.ifInfo['MR']['penetration']['Market Sales per Household']
      a.us_industry_sales_per_household = this.ifInfo['MR']['penetration']['US Sales per Household']
      a.opportunity_index_household = this.ifInfo['MR']['penetration']['Opportunity Index Household']

      a.market_area_population = this.ifInfo['MR']['income']['Population']
      a.market_area_households = this.ifInfo['MR']['income']['Households']
      a.per_capita_income = this.ifInfo['MR']['income']['Per Capita Income']
      a.mediab_hh__income = this.ifInfo['MR']['income']['Median HH Income']
      a.business_values_insights_date = monthNames[new Date(g).getMonth()] + " " + new Date(g).getFullYear();

      a.sales_approach_quartile1 =  this.ifInfo.multiples.data['Quartile 1']['sales']
      a.sales_approach_median =  this.ifInfo.multiples.data['Median']['sales']
      a.sales_approach_quartile3 =  this.ifInfo.multiples.data['Quartile 3']['sales']
      a.earnings_approach_quartile1 =  this.ifInfo.multiples.data['Quartile 1']['earnings']
      a.earnings_approach_median =  this.ifInfo.multiples.data['Median']['earnings']
      a.earnings_approach_quartile3 =  this.ifInfo.multiples.data['Quartile 3']['earnings']

      a.if_industry_code =  this.ifInfo.naics
      a.if_industry_name =  this.ifInfo.industry
      a.if_industry_sales_class =  this.ifInfo.IF['sales-class']
      a.financial_insights_date =  this.ifInfo.IF['period']

      a.gross_margin_percentage =  this.ifInfo.IF.spend['Gross Margin'].percentage;
      a.office_owner_compensation_percentage =  this.ifInfo.IF.spend['Officer-Owner-Compensation'].percentage;
      a.depreciation_percentage =  this.ifInfo.IF.spend['Depreciation'].percentage;
      a.operating_expense_percentage =  this.ifInfo.IF.spend['Operating Expenses'].percentage;
      a.operating_income_percentage =  this.ifInfo.IF.spend['Operating Income'].percentage;
      a.after_tax_net_profit_percentage =  this.ifInfo.IF.spend['After Tax Net Profit'].percentage;
      a.owner_earnings_percentage =  this.ifInfo.IF.spend['Owner Earnings'].percentage;
      a.account_receivable_percentage =  this.ifInfo.IF.spend['Accounts Receivable: Total Assets'].percentage;
      a.account_payable_percentage =  this.ifInfo.IF.spend['Accounts Payable: TLNW'].percentage;
      a.net_worth_assets_percentage =  this.ifInfo.IF.spend['Net Worth: Assets'].percentage;

      a.gross_margin_dollar =  this.ifInfo.IF.spend['Gross Margin'].dollar;
      a.office_owner_compensation_dollar =  this.ifInfo.IF.spend['Officer-Owner-Compensation'].dollar;
      a.depreciation_dollar =  this.ifInfo.IF.spend['Depreciation'].dollar;
      a.operating_expense_dollar =  this.ifInfo.IF.spend['Operating Expenses'].dollar;
      a.operating_income_dollar =  this.ifInfo.IF.spend['Operating Income'].dollar;
      a.after_tax_net_profit_dollar =  this.ifInfo.IF.spend['After Tax Net Profit'].dollar;
      a.owner_earnings_dollar =  this.ifInfo.IF.spend['Owner Earnings'].dollar;
      a.account_receivable_dollar =  this.ifInfo.IF.spend['Accounts Receivable: Total Assets'].dollar;
      a.account_payable_dollar =  this.ifInfo.IF.spend['Accounts Payable: TLNW'].dollar;
      a.net_worth_assets_dollar =  this.ifInfo.IF.spend['Net Worth: Assets'].dollar;

      a.account_payable_revenue = this.ifInfo.IF.benchmarks['Accounts Payable: Revenue'];
      a.current_ratio = this.ifInfo.IF.benchmarks['Current Ratio'];
      a.days_payable = this.ifInfo.IF.benchmarks['Days Payable'];
      a.net_working_capital_revenue = this.ifInfo.IF.benchmarks['Net Working Capital Revenue'];
      a.days_receivable = this.ifInfo.IF.benchmarks['Days Receivable'];
      a.interest_coverage = this.ifInfo.IF.benchmarks['Interest Coverage'];
      a.current_liabilites = this.ifInfo.IF.benchmarks['Current Liabilities: NW'];
      a.loans_notes = this.ifInfo.IF.benchmarks['Loans‐Notes Payable: Net Worth'];
      a.modified_z = this.ifInfo.IF.benchmarks['Modified Z Score'];
      a.total_liabilities = this.ifInfo.IF.benchmarks['Total Liabilties: Net Worth'];

      Object.values(a).forEach((element,index) => {
        let b ="";
        if(element && element.includes(',')){
          b = element.replace(/,/g, ".");
        }else {
          b = element;
        }
        this.filtered_company_profile_list.push(b);
      })
      return this.filtered_company_profile_list;
    },
    getCsvData() {
      let csvData = [
        [
          'Company',
          'Original Name',
          'Infogroup ID',
          'Unique ID',
          'Street',
          'City',
          'State',
          'Zip',
          'Industry Code',
          'Industry',
          'Contact First',
          'Contact Last',
          'Phone',
          'URL',
          'Operation Detail Release',
          'Location Annual Sales',
          'Location Employment',
          'Corporate Annual Sales',
          'Corporate Employment',
          'Market Insights Date',
          'Market Industry Code',
          'Market Industry',
          'Market Area',
          'Industry Operations',
          'Location Sales Rank',
          'Industry Market Sales Volume',
          'Average Site Sales',
          'Average Small Business Sales',
          'Industry Market Sales per Person',
          'US Industry Sales per Person',
          'Opportunity Index',
          'Industry Market Sales per Household',
          'US Industry Sales per Household',
          'Opportunity Index',
          'Market Area Population',
          'Market Area Households',
          'Per Capital Income',
          'Median Household Income',
          'Business Value Insights Date',
          'Sales Approach Quartile1',
          'Sales Approach Median',
          'Sales Approach Quartile3',
          'Earnings Approach Quartile1',
          'Earnings Approach Median',
          'Earnings Approach Quartile3',
          'IF Industry code',
          'IF Industry name',
          'IF Sales class',
          'Financial Insights Date',
          'Gross Margin %',
          'Officer-Owner Compensation %',
          'Depreciation %',
          'Operating Expense %',
          'Operating Income %',
          'After Tax Net Profit %',
          'Owner Earnings %',
          'Accounts Receivable/Total Assets %',
          'Accounts Payable/TLNW %',
          'Net Worth/Assets %',
          'Gross Margin $',
          'Officer-Owner Compensation $',
          'Depreciation $',
          'Operating Expense $',
          'Operating Income $',
          'After Tax Net Profit $',
          'Owner Earnings $',
          'Accounts Receivable/Total Assets $',
          'Accounts Payable/TLNW $',
          'Net Worth/Assets $',
          'Accounts Payable/Revenue',
          'Current Ratio',
          'Days Payable',
          'Net Working Capital/Revenue',
          'Days Receivable',
          'Interest Coverage',
          'Current Liabilities/Net Worth',
          'Loans Notes Payable/Net Worth',
          'Modified Z Score',
          'Total Liabilties/Net Worth'
        ],
      ]

      csvData.push(this.getFormattedData);
      return csvData;
    },
  },


  methods: {
    switchView: function (type) {
      this.view = type;
    },
     numberWithPoints(x) {
      if (typeof x === 'number') {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } else if(x === null){
        return x;
      }else
      {
        return x.replace(/,/g, '.');
      }
    },
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += "\n";
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Company Profile.csv';
      anchor.click();
    },
  },
};
</script>
<style lang="scss">


.finanical-insights-body {
  .header-box {
    display: flex;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }

  .md-collapse-content {
    padding: 0;
  }

  .financal-report-col-1 {
    display: flex;
    align-items: center;
  }

  .fi-profile-pdf-box {
    display: flex;
    justify-content: flex-end;
  }

  .profile-title {
    font-size: 24px;
    font-weight: 400;
  }
}

.comp-profile {
  display: flex;
  align-items: start;

  .md-layout {
    text-align: center;

    p {
      margin-left: 0 !important;
    }
  }

  .market-insights {
    p {
      color: #3b7ef1;
    }
  }
}

.table-box-margin {
  .md-layout-item {
    .md-card {
      margin: 15px 0 !important;
    }
  }
}

.company-terms {
  p {
    margin: 0 !important;
  }
}

.finanical-insights-body {
  .header-box {
    display: flex;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }

  .md-collapse-content {
    padding: 0;
  }

  .financal-report-col-1 {
    display: flex;
    align-items: center;
  }

  .fi-profile-pdf-box {
    display: flex;
    justify-content: flex-end;
  }

  .profile-title {
    font-size: 24px;
    font-weight: 400;
  }
}

.comp-profile {
  display: flex;
  align-items: start;

  .md-layout {
    text-align: center;

    p {
      margin-left: 0 !important;
    }
  }

  .market-insights {
    p {
      color: #3b7ef1;
    }
  }
}

.table-box-margin {
  .md-layout-item {
    .md-card {
      margin: 15px 0 !important;
    }
  }
}

.company-terms {
  p {
    margin: 0 !important;
  }
}
</style>

